import{Route, Routes} from "react-router-dom"
import BuyMiner from "./pages/buy-miner";
import Home from "./pages/home";
import Dashboard from "./pages/dashboard";
import Deposits from "./pages/deposits";
import Login from "./pages/login";
import Profile from "./pages/profile";
import SignUp from "./pages/sign-up";
import SignIn from "./pages/sign-in";
import Withdraw from "./pages/withdraw";
import NavLinks from "./pages/nav-links";

function App() {
  return (
    
    <div className="">  
      <Routes>
      <Route path="/" element={<Home/>}></Route>
      <Route path="/buy-miner" element={<BuyMiner/>}></Route>
      <Route path="/dashboard" element={<Dashboard/>}></Route>
      <Route path="/deposits" element={<Deposits/>}></Route>
      <Route path="/login" element={<Login/>}></Route>
      <Route path="/profile" element={<Profile/>}></Route>
      <Route path="/sign-up" element={<SignUp/>}></Route>
      <Route path="/sign-in" element={<SignIn/>}></Route>
      <Route path="/withdraw" element={<Withdraw/>}></Route>
      <Route path="/nav-links" element={<NavLinks/>}></Route>
      </Routes>
    </div>
  );
}

export default App;
